var Views = new (class Views extends AbstractModule {

  constructor() {
    super("Views");

    this._widget_open = Dom.parent.location.hash.indexOf('chat-open') > -1
                        || Utils.sessionStorage('opened') == true;

    this._forced_view = null;
    this._forced_state = undefined;
    if (Dom.parent.location.hash.indexOf('chat-open') > -1) {
      let match = Dom.parent.location.hash.match(/chat\-open\-((?:[\w-](?!state))+)(?:\-state\-([\w-]+))?/);
      if (match) {
        this._forced_view = match[1];
        if (match.length >= 2) {
          if (match[2] == "null") match[2] = null;
          if (/^\d+$/.test(match[2])) match[2] = ~~match[2];
          this._forced_state = match[2];
        }
      }
    }

    this._mainView        = null;
    this._subViews        = {};
    this._overlayViews    = {};

    this._defaultBranch   = 'conversations';

    this._currentBranch   = Utils.sessionStorage('current-view-branch') || null;
    this._currentDepth    = parseInt(Utils.sessionStorage('current-view-depth')) || 0;
    this._currentOverlay  = Utils.sessionStorage('current-view-overlay') || null;

    this._previousTranslate = 0;

    /** @type {Record<string, (name?: string, state?: string) => { name: string, state: string }>} */
    this._aliases = {
      'meetings': () => ({
        name: 'iframe',
        state: this.app._meetings_base_url
      }),
      'iframe': (name, state) => {
        return {
          name: name,
          state: state
        };
        // if (this.app._isVideoChatUrl(state)) {
        //   return {
        //     name: 'video-chat',
        //     state: state
        //   };
        // }
        // else {
        //   return {
        //     name: name,
        //     state: state
        //   };
        // }
      }
    }

    if (this._currentBranch == "null") this._currentBranch = null;
  }

  _initAfterWidget() {
    this.forEach(view => {
      view.attachSlaask(this.app);
    })
    if (Dom.parent.location.hash.indexOf('chat-open') > -1 && this.app._save_open_state)
      Utils.sessionStorage('opened', true);
    this._initEventHandlers();
  }

  _initAfterGuest() {
    if (this._widget_open) {
      requestAnimationFrame(() => { Dom.showWidget({ animate: false }); });
    }
  }

  _initEventHandlers() {
    this.app.on('close', () => {
      this._widget_open = false;
      if (this.app._save_open_state) Utils.sessionStorage('opened', this._widget_open);
    });
    Dom.on('open', () => {
      this._widget_open = true;
      if (this.app._save_open_state) Utils.sessionStorage('opened', this._widget_open);
      this._turnActive(this.current);
    });
    Dom.get('widget').when('ready', () => {
      if (this._forced_view) this.jumpToViewByName(this._forced_view, this._forced_state);
      else this.applyView();
    });
  }

  /**
   * widgetOpen
   * Represents the "stored" state of "open".
   * Equals to "true" during initialization if the widget should be opened,
   * even if it is physically closed at that moment.
   * @return {boolean}
   */
  get widget_open() {
    return this._widget_open;
  }

  add(view) {
    if (view.overlay) {
      this._overlayViews[view.name] = view;
    }
    else if (!view.branch) {
      this._mainView = view;
    }
    else {
      if (!this._subViews[view.branch]) this._subViews[view.branch] = {};
      this._subViews[view.branch][view.depth] = view;
    }
    view.on('soapy-changed', soapy => {
      if (this.didEventHappen('ready')) {
        this._syncHeaderBack();
        if (view == this.current) {
          this.applyView();
        }
      }
    });
    if (this.app) view.attachSlaask(this.app);
  }

  forEach(cb) {
    if (this._mainView) cb(this._mainView);
    Utils.forEach(this._overlayViews, view => {
      cb(view);
    });
    Utils.forEach(this._subViews, viewsInBranch => {
      Utils.forEach(viewsInBranch, view => {
        cb(view);
      })
    });
  }

  appendToDom() {
    let mover = Dom.findById('widget', 'slaask-widget-views-mover');
    this.forEach(view => {
      mover.appendChild(view.getElement());
    });
    this.forEach(view => {
      view._initGlobalEventListeners();
    });
    this.applyView();
    this._eventHappened('ready');
  }

  jumpToPrevious(strict = true) {
    let view = this.getPrevious();
    if (!view) {
      if (strict) throw "There is no previous branch.";
      else return false;
    }

    this.current.onLeave()
    this._currentBranch   = view.branch;
    this._currentDepth    = view.depth;
    this._currentOverlay  = null
    this.applyView();
    return true;
  }

  jumpToNext() {
    let view = this.getNext();
    if (!view) throw "There is no next branch.";

    this.current.onLeave()
    this._currentBranch   = view.branch;
    this._currentDepth    = view.depth;
    this._currentOverlay  = null
    this.applyView();
  }

  jumpToView(branch, depth, overlayName, state) {
    if (!overlayName && branch && !this._subViews[branch][depth]) throw `View on branch ${branch} with depth ${depth} doesn't exist.`;
    if (this.isCurrentViewAndState(branch, depth, overlayName, state)) return;
    
    this.current.onLeave()
    this._currentBranch   = branch;
    this._currentDepth    = parseInt(depth);
    this._currentOverlay  = overlayName || null;

    if (Utils.defined(state)) this.current.setState(state);
    this.applyView();
  }

  jumpToViewByName(name, state) {
    [name, state] = this._checkAlias(name, state);
    let [branch, depth, overlay] = this._nameToBranchDepth(name);

    this.jumpToView(branch, depth, overlay ? name : null, state);
  }

  getByName(name) {
    [name] = this._checkAlias(name, null);
    let [branch, depth, overlay] = this._nameToBranchDepth(name);
    return this.get(branch, depth, overlay ? name : null);
  }

  getByBranchDepth(branch, depth) {
    return !branch
            ? this._mainView
            : this._subViews[branch][depth];
  }

  getPrevious(branch, depth, handleSoapy = true) {
    if (!Utils.defined(branch)) branch = this._currentBranch;
    if (!Utils.defined(depth)) depth = this._currentDepth;
    if (!branch) return null;
    depth--;
    if (depth == -1) {
      branch = null;
      depth = 0;
    }
    if (handleSoapy) {
      let soapyDestination = this._handleSoapy(branch, depth, -1)
      if (soapyDestination) return this.getByBranchDepth(soapyDestination[0], soapyDestination[1]);
      else return null;
    }
    else {
      let previousView = this.getByBranchDepth(branch, depth);
      if (!previousView && depth > 0) return this.getPrevious(branch, depth, handleSoapy);
      return this.getByBranchDepth(branch, depth);
    }
  }

  getNext(branch, depth, handleSoapy = true) {
    if (!Utils.defined(branch)) branch = this._currentBranch;
    if (!Utils.defined(depth)) depth = this._currentDepth;
    if (!branch) branch = this._defaultBranch;
    else depth++;
    if (handleSoapy) {
      let soapyDestination = this._handleSoapy(branch, depth, 1)
      if (soapyDestination) return this.getByBranchDepth(soapyDestination[0], soapyDestination[1]);
      else return null;
    }
    else return this.getByBranchDepth(branch, depth);
  }

  get current() {
    const currentView = this.get(this._currentBranch, this._currentDepth, this._currentOverlay);

    if (currentView) {
      return currentView;
    }
    else {
      this._currentBranch = null;
      this._currentDepth = 0;
      this._currentOverlay = null;

      return this.get(this._currentBranch, this._currentDepth, this._currentOverlay)
    }
  }

  get(branch, depth, overlayName) {
    return this._overlayViews[overlayName] || this.getByBranchDepth(branch, depth);
  }

  isCurrentViewAndState(branch, depth, overlayName, state) {
    return branch == this._currentBranch && depth == this._currentDepth && overlayName == this._currentOverlay && this.current.getState() == state;
  }

  applyView() {
    if (Dom.get('widget').isReady()) {
      Dom.setWidgetSize(this.current._widgetSize || 'small', () => {
        let translateFunc = () => { return ((this._currentDepth + (this._currentBranch ? 1 : 0)) * 100); };
        let translate = translateFunc();
  
        let soapyDestination = this._handleSoapy(this._currentBranch, this._currentDepth, Math.sign(translate - this._previousTranslate));
        if (!soapyDestination && this.current.soapy)
          Utils.warn("Went to soapy view, but the mover sliped beyond the edge, fell into the ocean of the web and almost died. Now he is back on this soapy view and THAT'S VERY DANGEROUS.");
        if (soapyDestination) {
          this._currentBranch = soapyDestination[0];
          this._currentDepth  = soapyDestination[1];
          translate = translateFunc();
        }
  
        this.forEach(view => {
          view.hide();
        });
  
        let currentView;
        if (this._currentOverlay) {
          currentView = this._overlayViews[this._currentOverlay];
          currentView.updateBranchDepth(this._currentBranch, this._currentDepth);
        }
        else if (!this._currentBranch) {
          currentView = this._mainView;
        }
        else {
          currentView = this._subViews[this._currentBranch][this._currentDepth];
        }
  
        this._turnActive(currentView);
        currentView.display();
  
        this._syncHeaderBack();
        Dom.findById('widget', 'slaask-widget-views-mover').style.transform = `translateX(-${translate}%)`;
        let currentElement = this.current.element;
        if (translate > this._previousTranslate) {
          Dom.addClass('widget', currentElement, 'slaask-widget-slide-from-left');
          Dom.removeClass('widget', currentElement, 'slaask-widget-slide-from-right');
        }
        else {
          Dom.addClass('widget', currentElement, 'slaask-widget-slide-from-right');
          Dom.removeClass('widget', currentElement, 'slaask-widget-slide-from-left');
        }
        this._previousTranslate = translate;
        Utils.sessionStorage('current-view-branch',   this._currentBranch);
        Utils.sessionStorage('current-view-depth',    this._currentDepth);
        Utils.sessionStorage('current-view-overlay',  this._currentOverlay);
      })
    }
  }

  syncTitle() {
    this.current.syncTitle();
  }

  getMoverTransitionDuration() {
    let mover = Dom.findById('widget', 'slaask-widget-views-mover');
    if (mover) {
      return Utils.cacheSync('mover', 'transition-duration', () => {
        return parseFloat(Dom.get('widget').window.getComputedStyle(mover).transitionDuration) * 1000;
      });
    }
    else return 0;
  }

  _syncHeaderBack() {
    if (this.getPrevious())
      Dom.addClass('widget', 'slaask-widget-header-back-enabled');
    else
      Dom.removeClass('widget', 'slaask-widget-header-back-enabled');
  }

  /**
   * _handleSoapy
   * @param  {number} direction  -1 or 0 or 1. 0 is defaulted to 1.
   * @return {[branch, depth]}   or null
   */
  _handleSoapy(branch, depth, direction) {
    let current = this.getByBranchDepth(branch, depth);
    if (current && current.isSoapy(direction)) {
      if (!direction) direction = branch ? -1 : 1;
      let newView;
      if (direction == 1)
        newView = this.getNext(branch, depth, false);
      else if (direction == -1)
        newView = this.getPrevious(branch, depth, false);
      if (!newView) return null;
      else return this._handleSoapy(newView.branch, newView.depth, direction);
    }
    else if (!current && depth > 0 && direction < 0) return this._handleSoapy(branch, depth - 1, direction);
    else return [branch, depth];
  }

  _nameToBranchDepth(name) {
    if (this._overlayViews[name]) {
      return  this._currentOverlay
              ? [this.current.branch, this.current.depth, true]
              : !this.current.branch
                ? [this._defaultBranch, 0, true]
                : [this.current.branch, this.current.depth + 1, true];
    }
    else if (this._mainView.name == name) return [null, 0, false];
    else {
      return Utils.cacheSync('viewsName', name, () => {
        let res;
        Utils.forEach(this._subViews, (viewsInBranch, branch) => {
          Utils.forEach(viewsInBranch, (view, depth) => {
            if (view.name == name)
              res = [branch, depth, false];
          });
        });
        if (res) return res;
        throw "Unknown view name " + name;
      });
    }
  }

  /**
   * @param {string} name
   * @param {string} state
   * @returns {[string, string]} New name and state
   */
  _checkAlias(name, state) {
    const aliasFunction = this._aliases[name];
    if (aliasFunction) {
      const alias = aliasFunction(name, state);
      return [alias.name, alias.state];
    }
    else {
      return [name, state];
    }
  }

  _turnActive(view) {
    if (Dom.widget_displayed) {
      view._onActive();
      view.syncTitle();
      this.syncInputDisplay();
      Dom._syncHeaderEphemeralButton();
    }
  }

  syncInputDisplay() {
    if (this.didEventHappen('ready')) {
      let chatInput = this.current.chatInput();
      if (typeof chatInput == 'string') Dom.switchFooter(chatInput);
      else if (chatInput)
        Dom.switchFooter('input');
      else {
        if (chatInput === null) Dom.switchFooter(null);
        else if (chatInput === false) Dom.switchFooter('footer');
      }
    }
  }

});
